import React, { FC } from 'react';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { OutlinedInfoIcon } from 'assets/icons';
import { CommunicationsMessage } from '../communications.model';

interface CommunicationPopupProps {
  open: boolean;
  message: CommunicationsMessage;
  onClose: () => void;
  onCtaClick: () => void;
}

const CommunicationPopup: FC<CommunicationPopupProps> = ({ open, message, onClose, onCtaClick }) => {
  if (!open) return null;

  const hasCtaAction = Boolean(message.ctaText?.trim() && message.ctaAction?.trim());

  const handlePrimaryClick = () => {
    if (hasCtaAction) {
      onCtaClick();
    }
    onClose();
  };

  return (
    <CustomModal
      open={open}
      width="md:w-[335px]"
      borderRadius="rounded-2xl"
      className="max-h-[90vh] overflow-y-auto"
      closeModal={onClose}
      enableOutsideClick={false}>
      <div className="relative" role="dialog" aria-label={message.lines?.[0] || 'Account message'}>
        <div className="flex flex-col items-center gap-4 px-6 pb-2 pt-8">
          <OutlinedInfoIcon className="path-fill-current h-12 w-12 shrink-0 text-secondary" aria-hidden="true" />

          <div className="flex flex-col gap-2 text-center">
            {message.lines?.map((line, index) => (
              <div
                key={`communications-popup-line-${message.id}-${index}`}
                className={
                  index === 0 ? 'text-17px font-semibold text-primaryText' : 'text-sbase font-normal text-primaryText'
                }>
                {line}
              </div>
            ))}
          </div>
        </div>

        <div className="m-6 mt-4 flex flex-col gap-3">
          <CustomButton
            id={`communications-popup-cta-${message.id}`}
            className="h-12 w-full"
            childrenContainerStyles="text-sbase font-semibold"
            type={ButtonType.PRIMARY}
            onClick={handlePrimaryClick}>
            {message.ctaText || 'Got it'}
          </CustomButton>
          {hasCtaAction ? (
            <CustomButton
              id={`communications-popup-dismiss-${message.id}`}
              className="h-12 w-full"
              childrenContainerStyles="text-sbase font-semibold"
              type={ButtonType.GHOST}
              onClick={onClose}>
              Not now
            </CustomButton>
          ) : null}
        </div>
      </div>
    </CustomModal>
  );
};

export default CommunicationPopup;
